import React from 'react';
import classnames from 'classnames';
import Sticky from '@wix/da-ds/pkg/Sticky';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './WidgetHeaderWide.scss';
const WidgetHeaderWide = ({ header, subHeader, extras, extrasWhenSticky, className, isSticky = false, bigger })=>{
    const renderInner = (isStuck = false)=>{
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], isStuck && s['root-stuck'], className)
        }, /*#__PURE__*/ React.createElement(Heading, {
            className: classnames(s['header'], bigger && s['bigger-header'])
        }, header), subHeader && /*#__PURE__*/ React.createElement("div", {
            className: s['sub-header']
        }, subHeader), isStuck ? extrasWhenSticky : extras);
    };
    return isSticky ? /*#__PURE__*/ React.createElement(Sticky, {
        className: s['sticky'],
        marginTop: 54
    }, (isStuck)=>renderInner(isStuck)) : renderInner();
};
export default WidgetHeaderWide;

//# sourceMappingURL=WidgetHeaderWide.js.map